import Immutable from 'immutable';

// constants
import { TOKEN_CREATE } from '../constants/tokenTypes';

// lib
import httpReducer from '../lib/httpReducer';

export default function(state = Immutable.Map(), action) {
  switch (action.type) {
    case TOKEN_CREATE: return httpReducer(state, action);
    default:           return state;
  }
}



// WEBPACK FOOTER //
// ./app/reducers/token.js